import React, {useRef, useState, Fragment, ComponentProps} from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import b_ from 'b_';

import {Button, Textinput, Popup} from 'client/common/components/lego';

import I18N from 'assets/i18n/brandlift-project';

import './share-button.css';
import {logError} from '@yandex-int/pythia-libs';

const b = b_.with('share-button');

const i18n = I18N.surveyPreview.shareButton;

interface OwnProps {
    slug?: string;
    mix?: string;
    previewLink?: string;
    buttonView?: ComponentProps<typeof Button>['view'];
}

const inputIdElem = 'mini__share-input';
const copyIdElem = 'mini__copy-button';

export default function ShareButton(props: OwnProps) {
    const anchorRef = useRef<HTMLButtonElement>(null);
    const [isPopupVisible, setIsPopupVisible] = useState(false);

    const togglePopup = () => setIsPopupVisible(!isPopupVisible);

    const refInput = (input: HTMLInputElement) => {
        try {
            if (input) {
                const inputElement = document.getElementById(inputIdElem) as HTMLInputElement;

                return inputElement && inputElement.select();
            }
        } catch (err) {
            logError({message: 'Error sharing survey from statistics', err});
        }
    };

    const {mix = '', slug, buttonView = 'default', previewLink} = props;

    const className = `${b()} ${mix}`;

    const link =
        previewLink ?? `${location.protocol}//${location.host}/quicksurvey/preview/${slug}`;

    const buttonTitle = i18n.tabsView.shareLink;

    return (
        <Fragment>
            <Button
                className={className}
                innerRef={anchorRef}
                view={buttonView}
                size='m'
                title={buttonTitle}
                onClick={togglePopup}
            >
                {buttonTitle}
            </Button>
            {isPopupVisible && (
                <Popup
                    className={b('popup')}
                    mainOffset={10}
                    target='anchor'
                    anchor={anchorRef}
                    view='default'
                    visible
                    onClose={togglePopup}
                    hasTail
                >
                    <p className={b('popup-title')}>{i18n.popupTitle}</p>
                    <Textinput
                        className={b('text-input')}
                        id={inputIdElem}
                        view='default'
                        pin='round-round'
                        size='m'
                        controlRef={refInput}
                        defaultValue={link}
                    />
                    <CopyToClipboard text={link}>
                        <Button
                            className={b('button')}
                            id={copyIdElem}
                            view='action'
                            size='m'
                            title={i18n.copyToBuffer}
                        >
                            {i18n.copyToBuffer}
                        </Button>
                    </CopyToClipboard>
                    <Button
                        className={b('button')}
                        view='default'
                        size='m'
                        title={i18n.close}
                        onClick={togglePopup}
                    >
                        {i18n.close}
                    </Button>
                </Popup>
            )}
        </Fragment>
    );
}
